<template>
  <div :class="{'hidden':hidden}">
    <div class="oms-pagination">
      <el-row type="flex" justify="space-between">
        <el-col :span="24">
          <div class="oms-pages">
            <div class="checkout-size" v-if="showFooterText">
              <span>
                <span v-if="showSelectNum">
                  当前选中
                  <i>{{selection.length}}</i>条,
                </span>
                共
                <i>{{total}}</i>条，
              </span>
              <span class="page-size">
                每页
                <el-input
                  size="mini"
                  v-model="defaultPageSize"
                  @blur="paginationSizeBlur(defaultPageSize)"
                  @keyup.13.native="paginationSizeChange(defaultPageSize)"
                ></el-input>条
              </span>
            </div>
            <el-pagination
              small
              :background="background"
              :current-page.sync="currentPage"
              :page-size.sync="pageSize"
              :layout="layout"
              :total="total"
              v-bind="$attrs"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    showSelectNum: {
      type: Boolean,
      default: true
    },
    showFooterText: {
      type: Boolean,
      default: true
    },
    selection: {
      type: Array,
      default() {
        return [];
      }
    },
    total: {
      required: true,
      default: 0
    },
    page: {
      default: 1
    },
    limit: {
      default: 100
    },
    layout: {
      type: String,
      default: 'prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: false
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit('update:page', val);
      }
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit('update:limit', val);
      }
    }
  },
  watch: {
    limit: {
      handler(val) {
        this.defaultPageSize = Number(val);
      },
      immediate: true
    }
  },
  data() {
    return {
      defaultPageSize: 100
    };
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val });
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize });
    },
    // 每页条数改变时触发
    paginationSizeChange(val) {
      if (val > 5000) {
        this.defaultPageSize = 5000;
        val = 5000;
      }
      if (val < 1) {
        this.defaultPageSize = 1;
        val = 1;
      }
      this.$emit('pagination-size-change', val);
    },
    // 更改页数后 没有回车 需要把值传入父组件
    paginationSizeBlur(val) {
      this.$emit('pagination-size-blur', val);
    }
  }
};
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 16px 0;
  float: right;
}
</style>
